class TwoColumns {
  constructor(element) {
    this.element = element
    this.items = [...this.element.querySelectorAll('.teaser')]
    this.heights = []
  }
  
  init () {
    this.heights = this.items.map(item => {
      return item.getBoundingClientRect().height
    })
  
    let maxHeight = this.heights.reduce((a, b) => {
      return Math.max(a, b)
    })
  

    if (window.innerWidth >= 768) {
      for (let item of this.items) {
        item.style.minHeight = `${maxHeight}px`
      }
    }
  }
  
  update () {
    
    window.addEventListener('resize', () => {
      for (let item of this.items) {
        item.style.minHeight = 'unset'
      }
      
      if (window.innerWidth >= 768) {
        this.init()
      }
    },{ passive: true})
  }
  
  
}

export default TwoColumns
